import { sourcePoints as points } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

type SourcePoint = (typeof points)[number];

const toneIcon: Record<SourcePoint["tone"], string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function SourceNote() {
  return (
    <section id="sources" className="w-full border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <SectionHeading
          icon="ri-shield-check-line"
          eyebrow="信源规则 · SOURCE LABELS"
          title="每条线报都带来源标签，判断权留给你"
          desc="独家来源、内部爆料、匿名投稿，本质上是不同的可信度等级。我们把标注规则写在明面上，方便你自己衡量哪条值得跟进。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {points.map((point, index) => (
            <Reveal key={point.title} delay={index * 50}>
              <div className="flex h-full flex-col rounded-lg border border-background-300 bg-background-50 p-5">
                <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${toneIcon[point.tone]}`}>
                  <i className={`${point.icon} text-xl`} />
                </span>
                <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">{point.title}</h4>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={60}>
          <div className="mt-6 flex flex-col gap-3 rounded-lg border border-background-300 bg-background-50 p-5 md:p-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-start gap-3">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center text-primary-600">
                <i className="ri-information-line text-lg" />
              </span>
              <p className="max-w-3xl text-sm leading-relaxed text-foreground-700">
                本站为内容聚合与讨论的演示站点，页面所示话题、线报与评论均为虚构示例，不对应任何真实人物或事件。
                所有信息以「投稿人表述」形式呈现，读者请自行核实，勿据此对任何个人或组织作出判断。
              </p>
            </div>
            <a
              href="#top"
              className="flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-2.5 text-sm font-label font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-arrow-up-line text-base" />
              回到顶部看话题墙
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}